import React from 'react';

export function OlympicGroundIcon() {
  return (
    <svg width="105" height="26" viewBox="0 0 105 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-49.9999 28.8621C-29.13 -17.1465 9.5828 2.59873 24.5234 15.2507C18.6771 12.7224 18.212 17.3744 -7.12212 24.9656C-27.3894 31.0386 -44.1536 33.0788 -49.9999 28.8621Z"
        fill="#D1D5DB"
      />
      <path
        d="M-49.9852 28.8727C19.162 -0.185601 82.1496 16.7651 105 28.8727C96.0585 26.4532 54.3318 26.4492 15.5855 33.7138C-15.4116 39.5255 -41.0437 32.908 -49.9852 28.8727Z"
        fill="#FEECDC"
      />
    </svg>
  );
}
